// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2kLp5","error":"Textarea_error__1fImq","readonly":"Textarea_readonly__2tE81","disabled":"Textarea_disabled__TXTlH"};